import React, { Component } from "react";
import { Route, withRouter, Switch } from "react-router-dom";
import $ from "jquery";
import "./App.css";
import admin, { getMyStatus } from "./js/admin";
import { auth, switchServer, appRoot, get, navigateToLogin, ajaxErrorEnd, getString, globalServers, post, isBackup, navigateTo, setRem, _log, setAuthServer, getSetting } from "./js/auth";
import Login from "./components/login/Login";
import "./css/eatwithme.css";
import "./css/allergen.css";
import "./fonts/fonts.css";
import Menu from "./components/menus/Menu";
import { connect } from "react-redux";
import { dispatchChangeLanguage } from "./actions/EatWithMeActions";
import { locals, admin_locals } from "./langs/languages";
import Register from "./components/login/Register";
import PasswordForgotten from "./components/login/PasswordForgotten";
import PasswordReset from "./components/login/PasswordReset";
import EatWithMeActions from "./actions/EatWithMeActions";
import TablesOverview from "./main/tablesOverview/TablesOverview";
import DrinkBar from "./main/drinkbar/DrinkBar";
import Kitchen from "./main/kitchen/Kitchen";
import ProductionLine from "./main/productionLine/ProductionLine";
import TableReservations from "./main/tableReservations/TableReservations";
import { store } from ".";
import Profile from "./admin/Profile";
import Consent from "./admin/Consent";
import WaiterScreen from "./main/kitchen/WaiterScreen";
import GuestScreen from "./main/kitchen/GuestScreen";
import Softphone from "./main/tablesOverview/Softphone";
import CanAccess from "./components/CanAccess";
import _, { set } from "lodash";


class App extends Component {

  isOauthLoginPath = (pathname) => {
    return pathname?.startsWith("/oauth/login") || pathname?.startsWith("/auth/login");
  }

  isPublicAuthPath = (pathname) => {
    return pathname?.startsWith("/consent") ||
      pathname?.startsWith("/login") ||
      this.isOauthLoginPath(pathname) ||
      pathname?.startsWith("/passwordReset") ||
      pathname?.startsWith("/passwordForgotten") ||
      pathname?.startsWith("/register");
  }

  hasOauthRequestContext = () => {
    const queryParams = new URLSearchParams(this.props.history.location.search || "");
    return !!(queryParams.get("request_id") || sessionStorage.getItem("oauthRequestId") || this.isOauthLoginPath(this.props.history.location.pathname));
  }

  getOauthSearch = () => {
    const currentPath = this.props.history.location.pathname;
    const currentSearch = this.props.history.location.search || "";
    const params = new URLSearchParams(currentSearch);
    const requestId = params.get("request_id") || sessionStorage.getItem("oauthRequestId");
    const redirectTarget = this.isPublicAuthPath(currentPath) ? "" : `${currentPath}${currentSearch}`;
    if (!requestId)
      return currentSearch;
    params.set("request_id", requestId);
    if (redirectTarget && !params.get("redirect")) {
      params.set("redirect", redirectTarget);
    }
    return "?" + params.toString();
  }

  redirectToLogin = () => {
    const currentPath = this.props.history.location.pathname;
    const currentSearch = this.props.history.location.search || "";
    const redirectTarget = this.isPublicAuthPath(currentPath) ? "" : `${currentPath}${currentSearch}`;

    if (this.hasOauthRequestContext()) {
      const oauthSearch = this.getOauthSearch();
      if (currentPath !== "/oauth/login" || currentSearch !== oauthSearch) {
        this.props.history.push({ pathname: "/oauth/login", search: oauthSearch });
      }
      return;
    }

    if (currentPath !== "/login") {
      const params = new URLSearchParams();
      if (redirectTarget) {
        params.set("redirect", redirectTarget);
      }
      this.props.history.push({ pathname: "/login", search: params.toString() ? `?${params.toString()}` : "" });
    }
  }

  check = () => {
    const t = this;
    if (t.props.history.location.pathname.startsWith("/consent")) {
      t.getTableServiceStatus()
    } else {
      const tt = t.onloadIndexHtml(t);
      if (tt?.done)
        tt.done(() => {
          if (localStorage.getItem("hashBeforeRefresh")) {
            const url = localStorage.getItem("hashBeforeRefresh");
            //setTimeout(() => {
            localStorage.removeItem("hashBeforeRefresh")
            window.location.replace(url);
            //alert("Navigating to " + "/" + localStorage.getItem("hashBeforeRefresh"));
            //}, 5000);
          }
        });
    }
  }

  oldcheck = () => {
    var t = this;
    auth
      .checkSocialLoginStatus()
      .done(function () {
        if (t.props.history.location.pathname.startsWith("/consent")) {
          t.getTableServiceStatus()
        } else { t.onloadIndexHtml(t); }
      })
      .fail(function () {
        if (t.props.history.location.pathname.startsWith("/consent")) {
          t.getTableServiceStatus()
        } else {

          if (localStorage.server !== auth.globalserver && typeof localStorage.globalId != "undefined") {
            setAuthServer(auth.globalserver);
            switchServer({ globalId: localStorage.globalId, serverUrl: localStorage.server }).done(() => {
              t.props.history.push("/");
            }).fail(() => {
              if (!t.isPublicAuthPath(t.props.history.location.pathname)) {
                t.redirectToLogin();
              }
            });
            return;
          }

          let local = locals[localStorage.language];
          let admin_local = admin_locals[localStorage.language];
          t.props.changeLanguage(local, admin_local, localStorage.language, localStorage.country);
          if (t.isPublicAuthPath(t.props.history.location.pathname))
            return;
          t.redirectToLogin();
        }
      });

  };

  componentDidMount = () => {

    const queryParams = new URLSearchParams(this.props.history.location.search);

    const loginToken = queryParams.get("loginToken");
    const server_url = queryParams.get("server_url");
    const instance = queryParams.get("instance");
    const restaurant_id = queryParams.get("restaurant_id");
    sessionStorage.customerScreen = queryParams.get("t");

    if (loginToken) {
      setAuthServer(server_url);
      post("login?instance=" + instance, "username=" + encodeURIComponent("authtoken:" + restaurant_id + "/" + loginToken) + "&password=" + encodeURIComponent(loginToken) + "&user=true", {}, true, 0, false, 30000)
        .done(data => {
          if (data == null) {
            alert("Failed to authenticate user! Username or password is wrong!");
          } else {
            localStorage.id = data.customer.id;
            localStorage.email = data.customer.email;
            localStorage.name = data.customer.name;
            localStorage.surname = data.customer.surname;
            localStorage.sessionId = data.sessionId;
            localStorage.instance = instance;
          }


          //loginBackground(loginUrl)
          //                .done(() => {
          get("tableService/getLocalFromGlobalId/" + restaurant_id).done(id => {
            localStorage.restaurantSelected = id;
            admin.getMyStatus(data => {
              localStorage.instance = instance;
              this.props.history.push(this.props.history.location.pathname);
            })
          });
        }).fail(() => {
          auth.ajaxError = false;
          console.error("Login failed with login token");
        });
    } else {
      this.check();
    }
  }

  componentDidUpdate = () => {
    if (!this.props.myStatus.id && !this.isPublicAuthPath(this.props.history.location.pathname)) {
      const queryParams = new URLSearchParams(this.props.history.location.search);
      const loginToken = queryParams.get("loginToken");
      sessionStorage.customerScreen = queryParams.get("t");
      if (!loginToken) {
        this.redirectToLogin();
      } else {
        const server_url = queryParams.get("server_url");
        const instance = queryParams.get("instance");
        const restaurant_id = queryParams.get("restaurant_id");

        if (loginToken) {
          setAuthServer(server_url);
          post("login?instance=" + instance, "username=" + encodeURIComponent("authtoken:" + restaurant_id + "/" + loginToken) + "&password=" + encodeURIComponent(loginToken) + "&user=true", {}, true, 0, false, 30000)
            .done(data => {
              if (data == null) {
                alert("Failed to authenticate user! Username or password is wrong!");
              } else {
                localStorage.id = data.customer.id;
                localStorage.email = data.customer.email;
                localStorage.name = data.customer.name;
                localStorage.surname = data.customer.surname;
                localStorage.sessionId = data.sessionId;
                localStorage.instance = instance;
                localStorage.restaurantSelected = data.restaurant_id;
              }


              //loginBackground(loginUrl)
              //                .done(() => {
              get("tableService/getLocalFromGlobalId/" + restaurant_id).done(id => {
                localStorage.restaurantSelected = id;
                admin.getMyStatus(data => {
                  this.props.history.push(this.props.history.location.pathname);
                })
              });
            }).fail(() => {
              auth.ajaxError = false;
              console.error("Login failed with login token");
            });
        }
      }
    }
  }

  render() {

    window.ajaxErrorEnd = ajaxErrorEnd;
    const queryParams = new URLSearchParams(this.props.history.location.search);
    const loginToken = queryParams.get("loginToken");
    const css = getSetting("css");
    if (loginToken) {
      return null;
    }
    setRem();
    return (
      <React.Fragment>
        <style>{css}</style>
        <Switch>
          <Route path="/oauth/login" render={props => <Login {...props} keep="false" onLogin={this.onloadIndexHtml} />} />
          <Route path="/login" render={props => <Login {...props} keep="false" onLogin={this.onloadIndexHtml} />} />
          <Route path="/register" render={props => <Register {...props} keep="false" onLogin={this.onloadIndexHtml} />} />
          <Route path="/passwordForgotten" render={props => <PasswordForgotten {...props} keep="false" />} />
          <Route path="/passwordReset" render={props => <PasswordReset {...props} keep="false" />} />
          <Route path="/tablesOverview" render={props =>
            <CanAccess resource="sales.tablesoverview.view">
              <TablesOverview {...props} onReload={this.onReload} />
            </CanAccess>} />
          <Route path="/tableReservations" render={props => <TableReservations {...props} onReload={this.onReload} />} />
          <Route path="/drinkbar" render={props => <DrinkBar {...props} onReload={this.onReload} />} />
          <Route path="/kitchen" render={props => <Kitchen {...props} onReload={this.onReload} />} />
          <Route path="/waiterScreen" render={props => <WaiterScreen {...props} onReload={this.onReload} />} />
          <Route path="/guestScreen" render={props => <GuestScreen {...props} onReload={this.onReload} />} />
          <Route path={"/profile"} render={props => <Profile {...props} onReload={this.onReload} />} />
          <Route path={"/consent"} render={props => <Consent {...props} onReload={this.onReload} />} />
          <Route path="/productionLinesMenu/productionLine" render={props => <ProductionLine {...props} onReload={this.onReload} />} />
          <Route path="/" render={props => <Menu {...props} onReload={this.onReload} />} />
        </Switch>
        {this.props.voipphoneSelected && <Softphone />}
      </React.Fragment>
    );
  }

  getTableServiceStatus = () => {
    let query = new URLSearchParams(this.props.history.location.search);

    //getGlobal("adminService/" + query.get("rr") + "/getRestaurant").done(data => {
    localStorage.restaurantSelected = query.get("rr");
    setAuthServer(query.get("u").substring(0, query.get("u").length - 1));
    auth.getMyStatus(data => {
      localStorage.restaurantSelected = data.restaurant_id;
      auth.setMyStatus(data);
    })
    //})
  }

  onloadIndexHtml = () => {
    const t = this;
    const def = $.Deferred();
    const { resetRestaurants, changeLanguage } = this.props;

    let local = locals[localStorage.language];
    let admin_local = admin_locals[localStorage.language];
    changeLanguage(local, admin_local, localStorage.language, localStorage.country);

    if (this.props.history.location.pathname.startsWith("/login") || this.isOauthLoginPath(this.props.history.location.pathname)) {
      def.resolve();
      return def.promise();
    }
    admin.getMyStatus(
      async data => {
        try {
          //eslint-disable-next-line no-restricted-globals
          setLanguage(localStorage.language);
        } catch (e) {
          console.error("Failed to set language", e);
        }

        const href = window.location.href;
        if (href.indexOf(":3000") === -1 && auth.device.platform === "browser" && auth.myStatus.restaurant_global_id) {
          if (auth.server !== auth.globalserver) {
            var u = auth.server.replace("restaurant.eatwithme", "console.eatwithme").replace(":8448", "");
          } else if (!href.startsWith("https://console.eatwithme.online/#") && !href.startsWith("https://console-backup.eatwithme.online/#")) {
            if (isBackup())
              navigateTo("https://console-backup.eatwithme.online/" + window.location.hash);
            else {
              navigateTo("https://console.eatwithme.online/" + window.location.hash);
            }
            return;
          }
        }

        this.props.ai.initSpeach();

        if (data.status === "none") {
          //t.setState({ showLogin: true });
          return;
        }
        t.getRestaurants().done(restaurants => {
          var r = restaurants.find(r => (r.isActive === undefined || r.isActive) && r.id === Number(localStorage.restaurantSelected) && r.fromLocal);
          var server = auth.server + "/";
          if (!r) {
            r = restaurants.find(r => (r.isActive === undefined || r.isActive) && ((auth.server !== auth.globalserver && r.serverUrl === server && r.fromLocal) || (auth.server === auth.globalserver && r.serverUrl === "" && r.fromLocal)));
          }
          if (!r) {
            r = restaurants.find(r => ((r.isActive === undefined || r.isActive) && r.fromLocal));
          }
          if (r) {
            var serverUrl = !r.serverUrl ? auth.globalserver + "/" : r.serverUrl;

            if (auth.myStatus.is_global_server && serverUrl !== server) {
              console.log("Switch to server " + serverUrl);
              t.pickRestaurant(r.globalId, r.name, r.languages, r.serverUrl, r.backupUrl, r.instance);
              return;
            }
            localStorage.restaurantSelected = r.id;
            store.dispatch(EatWithMeActions.resetActiveRestaurant(localStorage.restaurantSelected));
            admin.getTables(data => {
              resetRestaurants({ restaurants: restaurants, restaurantTables: data.restaurantTables });
            });
            admin.getActiveMenuItems(data => {
              store.dispatch(EatWithMeActions.menuCategories(data.activeMenuCategories));
            });

            def.resolve();
          } else if (restaurants.length > 0) {
            /*
            admin.getTables(data => {
              resetRestaurants({ restaurants: restaurants, restaurantTables: data.restaurantTables });
              t.setState({ ...t.state, restaurantSelected: localStorage.restaurantSelected });
            });
            */
            navigateToLogin();
            def.resolve();
          } else {
            resetRestaurants({ restaurants: restaurants, restaurantTables: [] });
            def.resolve();
          }
        });
      },
      () => {
        console.log("App.js: failed to get status from server");
        console.log("localStorage.server=" + localStorage.server);
        console.log("localStorage.globalId=" + localStorage.globalId);
        if (localStorage.server !== auth.globalserver && typeof localStorage.globalId != "undefined") {
          const s = localStorage.server;
          setAuthServer(auth.globalserver);
          console.log("SWITCH");
          switchServer({ globalId: localStorage.globalId, serverUrl: s }).done(() => {
            t.props.history.push("/");
          }).fail(() => {
            console.log("FAILED TO LOGIN TO SERVER");
            if (!t.isPublicAuthPath(t.props.history.location.pathname)) {
              t.redirectToLogin();
            }
          });
          return;
        }

        auth.ajaxError = false;
        let local = locals[localStorage.language];
        let admin_local = admin_locals[localStorage.language];
        changeLanguage(local, admin_local, localStorage.language, localStorage.country);
        if (t.isPublicAuthPath(t.props.history.location.pathname))
          return;
        t.redirectToLogin();
        //t.setState({ showLogin: true });
      }

    );
    return def.promise();
  };

  pickRestaurant(restaurantId, name, languages, url, backupUrl, instance) {

    const originalServer = auth.server;
    const t = this;
    switchServer({ globalId: restaurantId, serverUrl: url, backupUrl: backupUrl, name: name, instance }).done(() => {

      //localStorage.server = auth.server;
      get("login/setRestaurant/" + localStorage.restaurantSelected)
        .done(() => {
          // eslint-disable-next-line no-restricted-globals
          t.onReload();
        })
        .fail(() => {
          auth.ajaxError = false;
          localStorage.restaurantSelected = 0;
          setAuthServer(auth.globalserver);
          setTimeout(() => {
            _log("LOGIN: Failed to set restaurant, reloading to login");
            // eslint-disable-next-line no-restricted-globals
            //location.reload();
          }, 1000);
        });
      //}
    });
  }

  onReload = () => {
    this.onloadIndexHtml().done(() => {
      if (localStorage.getItem("hashBeforeRefresh")) {
        //setTimeout(() => {
        window.location.replace(localStorage.getItem("hashBeforeRefresh"));
        //alert("Navigating to " + "/" + localStorage.getItem("hashBeforeRefresh"));
        localStorage.setItem("hashBeforeRefresh", "")
        //}, 5000);
      }
    });
  }

  getRestaurants() {
    var def = $.Deferred();
    admin.getRestaurants(function (data) {
      var restaurants = data.restaurants;
      if (!restaurants.length) {
        delete localStorage.globalId;
        delete localStorage.server;
        setAuthServer(auth.globalserver);
        navigateToLogin();
        return;
      }
      restaurants.forEach(r => r.fromLocal = true);
      if (auth.server !== auth.globalserver && !auth.myStatus.is_global_server) {
        admin.getGlobalRestaurants(
          function (gdata) {
            if (gdata?.restaurants) {
              gdata.restaurants.filter(r => restaurants.filter(rr => rr.globalId === r.globalId).length === 0).map(r => restaurants.push(r));
              gdata.restaurants.forEach(r => {
                r.fromGlobal = false;
                const rest = restaurants.find(rr => rr.globalId === r.globalId);
                rest.serverUrl = r.serverUrl;
                rest.localUrl = r.localUrl;
              });
            }
            def.resolve(restaurants);
          },
          (error) => {
            //auth.ajaxError = false;
            if (error.status === 403) {
              delete localStorage.globalId;
              delete localStorage.server;
              setAuthServer(auth.globalserver); 
              navigateToLogin();
            } else
              def.resolve(restaurants);
          }
        );
      } else {
        def.resolve(restaurants);
      }
    });
    return def.promise();
  }
}

function setLanguage(language) {
  get("login/setLanguage/" + language, undefined, undefined, undefined, false);
}

const mapStateToProps = state => {
  return {
    myStatus: state.rootReducer.myStatus,
    ai: state.rootReducer.ai,
    voipphoneSelected: state.rootReducer.voipphoneSelected
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetRestaurants: ({ restaurants, restaurantTables }) => {
      dispatch(EatWithMeActions.updateRestaurants(restaurants));
      dispatch(EatWithMeActions.updateRestaurantTables(restaurantTables));
    },
    changeLanguage: dispatchChangeLanguage(dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withRouter(App)));
